import { Association, Group, Opportunity, OrganizationManager } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { PARTICIPANT_STATUS } from "@shared/helpers/constants";
import { Fields, Relations } from "remult";
import { OpportunityParticipantEntityConfig } from "./config";
import { OpportunityParticipantFilters } from "./filters";
import { OpportunityParticipantMethods } from "./methods";

@HyperEntity("opportunity-participant", OpportunityParticipantEntityConfig)
export class OpportunityParticipant extends extender(
  OpportunityParticipantFilters,
  OpportunityParticipantMethods,
) {
  @Fields.id()
  id = "";

  @Relations.toOne<OpportunityParticipant, Opportunity>(
    () => Opportunity,
    "opportunityId",
  )
  opportunity?: Opportunity;

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne<OpportunityParticipant, Association>(() => Association, {
    field: "associationId",
  })
  association?: Association;

  @Fields.string({ dbName: "association_id" })
  associationId = "";

  @Relations.toOne<OpportunityParticipant, Group>(() => Group, {
    caption: "שיוך לקבוצה",
    field: "groupId",
  })
  group?: Group;

  @Fields.string({ dbName: "group_id", allowNull: true })
  groupId?: string;

  @Fields.boolean({ dbName: "has_declined_survey" })
  hasDeclinedSurvey = false;

  @Fields.boolean({ dbName: "registered_manually" })
  registeredManually = false;

  @Fields.string({ dbName: "matched_by_manager_id", allowNull: true })
  matchedByManagerId?: string;

  @Relations.toOne<OpportunityParticipant, OrganizationManager>(
    () => OrganizationManager,
    { field: "matchedByManagerId" },
  )
  matchedByManager?: OrganizationManager;

  @Fields.date({ dbName: "matched_at", allowNull: true })
  matchedAt?: Date;

  @Fields.date({
    dbName: "approved_at",
    allowNull: true,
    allowApiUpdate: false,
  })
  approvedAt?: Date;

  @Fields.number({ dbName: "match_weight", caption: "מכפיל מאצ'ים" })
  matchWeight = 1;

  @Fields.literal(() => PARTICIPANT_STATUS, { caption: "סטטוס" })
  status: (typeof PARTICIPANT_STATUS)[number] = "PENDING";

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
